import { render } from "./FormCollapsibleSection.vue?vue&type=template&id=103a9916&scoped=true"
import script from "./FormCollapsibleSection.vue?vue&type=script&lang=js"
export * from "./FormCollapsibleSection.vue?vue&type=script&lang=js"

import "./FormCollapsibleSection.vue?vue&type=style&index=0&id=103a9916&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103a9916"]])

export default __exports__